import React, {useState, useEffect} from "react";
import {Navigate, Outlet} from "react-router-dom";

const Auth = () => {
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("userData")));

  //   return userLoggedIn ? <Navigate to="/dashboard" /> : <Navigate to="/" />;
  return userData ? <Outlet /> : <Navigate to="/" />;
};

export default Auth;
